/* eslint-disable global-require */
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./store.prod');
} else {
  module.exports = require('./store.dev');
}



// WEBPACK FOOTER //
// ./src/app/store/index.js